import setScrollToHandler from 'core/DOM/setScrollToHandler'
import renderShoppingModule from './renderShoppingModule'
import individualState from 'core/DOM/individualState'
import updateContent from 'core/DOM/updateContent'

function updateDOM({ hcStorage, priceRange, content }) {
  if (hcStorage.location.state_acronym) {
    individualState(hcStorage.location.state_acronym)
  }

  if (priceRange) {
    renderShoppingModule(priceRange, hcStorage)
    setScrollToHandler()
  }

  if (content) {
    updateContent(content)
  }
}

export default updateDOM
